// mesbot/src/institution/InstitutionLayout.js
import React from "react";
import InstitutionSidebar from "./InstitutionSidebar";
import Overview from "./pages/Overview";
import Wellness from "./pages/Wellness";
import Students from "./pages/Students";
import Settings from "./pages/Settings";

const PAGE_MAP = {
  overview: Overview,
  wellness: Wellness,
  students: Students,
  settings: Settings,
};

export default function InstitutionLayout({ token, user, activePage, setActivePage, onLogout }) {
  const isDark = document.body.classList.contains("dark-mode");
  const PageComponent = PAGE_MAP[activePage] || Overview;

  return (
    <div className={`inst-app ${isDark ? "dark-mode" : ""}`}>
      <InstitutionSidebar
        user={user}
        activePage={activePage}
        setActivePage={setActivePage}
        onLogout={onLogout}
      />
      <main className="inst-main">
        <PageComponent token={token} user={user} />
      </main>
    </div>
  );
}
